import { QTooltip } from 'quasar'
import { applyTooltipDefaults } from 'src/plugins/helpers/tooltip-defaults'

export default () => {
  applyTooltipDefaults(QTooltip)
}
